var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"hero"},[_c('div',{staticClass:"hero-head"},[_c('Header')],1),_c('div',{staticClass:"hero-body"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }